
























































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import BrandMixin from "@/mixins/brandMixin";
import CurrenciesStore from "@/mixins/constants/currenciesStore";
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { ConfirmModalModes } from "@/data/enums";

// Types
import { IContract, IContractProduct } from "@/models/contracts";
import { ICurrency } from "@/models/constants";

@Component
export default class CProdChangeCurrencyModal extends Mixins(
  BrandMixin,
  CurrenciesStore,
  HasValidation
) {
  // Props

  @Prop({ required: true })
  public contract!: IContract;

  @Prop({ required: true })
  public contractProductId!: IContractProduct["id"];

  // Data

  public isLoading = true;
  public isReloading = false;
  public isProcessing = false;
  public hasRequestError = false;
  public form = this.initForm();

  // Life-cycle methods

  public async created() {
    this.loadData();
  }

  // Methods

  public initForm(): { currency_code: ICurrency["code"] } {
    return {
      currency_code: ""
    };
  }

  public async loadData() {
    try {
      await this.getCurrencies();
      this.hasRequestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.hasRequestError = true;
    } finally {
      this.isReloading = false;
      this.isLoading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public async validateBeforeSubmit() {
    if (this.formIsDisabled) return;

    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      const confirm = await this.$store.dispatch("ui/open/confirmModal", {
        config: {
          props: {
            autoClose: false,
            mode: ConfirmModalModes.PIN,
            confirmButtonText: this.$t("_action.change_currency"),
            message: this.$t("_sentence.cprod.confirm_currency_change", {
              oldCurrencyCode: this.contract.currency.code,
              newCurrencyCode: this.form.currency_code
            })
          },
          events: {
            confirmed: async () => {
              try {
                this.isProcessing = true;

                const { id, contract_id } = await this.switchCurrency();

                this.$store.dispatch("toast/show", {
                  message: this.$t("_sentence.cprod.currency_updated")
                });

                this.$router.push({
                  name: "admin__clientCProd",
                  params: {
                    contractId: contract_id,
                    productId: id
                  }
                });

                this.$emit("success");
                this.$emit("close");
              } catch (error) {
                this.$store.dispatch("api/handleError", error);
              } finally {
                this.isProcessing = false;
                confirm.close();
              }
            }
          }
        }
      });
    } catch (error) {
      this.isProcessing = false;
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }

  public switchCurrency() {
    return this.$store.dispatch(
      `data/${DataModules.CONTRACTS_PRODUCTS}/switchCurrency`,
      {
        contractId: this.contract.id,
        contractProductId: this.contractProductId,
        data: this.form
      }
    );
  }

  // Computed

  public get formIsValid() {
    return !_.isEqual(this.form, this.initForm());
  }

  public get formIsDisabled() {
    return (
      this.isLoading ||
      this.isReloading ||
      this.isProcessing ||
      !this.formIsValid ||
      this.hasErrors
    );
  }

  public get supportedCurrencies() {
    return _.orderBy(
      _.omitBy(
        this.brandCurrencies,
        ({ code }) => code === this.contract.currency.code
      ),
      "name",
      "asc"
    );
  }
}
